<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-2">
      <span class="text-sm text-gray-700">
        Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to {{ Math.min(currentPage * itemsPerPage, totalItems) }} of {{ totalItems }} results
      </span>
    </div>
    <div class="flex items-center space-x-2">
      <button
        @click="changePage(currentPage - 1)"
        :disabled="currentPage === 1"
        class="px-3 py-1 rounded-lg border border-gray-300 text-sm"
        :class="currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'"
      >
        Previous
      </button>
      <div class="flex space-x-1">
        <template v-for="page in getPageRange()" :key="page">
          <button
            v-if="typeof page === 'number'"
            @click="changePage(page)"
            class="px-3 py-1 rounded-lg text-sm min-w-[2.5rem]"
            :class="currentPage === page ? 'bg-primary-600 text-white' : 'text-gray-700 hover:bg-gray-50'"
          >
            {{ page }}
          </button>
          <span
            v-else
            class="px-3 py-1 text-gray-500"
          >
            {{ page }}
          </span>
        </template>
      </div>
      <button
        @click="changePage(currentPage + 1)"
        :disabled="currentPage === totalPages"
        class="px-3 py-1 rounded-lg border border-gray-300 text-sm"
        :class="currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  currentPage: number
  itemsPerPage: number
  totalItems: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:currentPage', page: number): void
}>()

const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage))

const getPageRange = () => {
  const delta = 2 // 当前页码两侧显示的页码数
  const range = []
  const rangeWithDots: (number | string)[] = [];
  let l: number | null = null

  for (let i = 1; i <= totalPages.value; i++) {
    if (i === 1 || i === totalPages.value || (i >= props.currentPage - delta && i <= props.currentPage + delta)) {
      range.push(i)
    }
  }

  range.forEach(i => {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1)
      } else if (i - l !== 1) {
        rangeWithDots.push('...')
      }
    }
    rangeWithDots.push(i)
    l = i
  })

  return rangeWithDots
}

const changePage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    emit('update:currentPage', page)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
</script> 